<template>
    <div v-click-outside="hidePopup">
        <button ref="menuButtonContainer" @click="openPopup()"
                class="inline-flex text-left w-full outline-none transition duration-300"
                :class="[buttonClass, justifyText]">
            <template v-if="label" class="relative">
                <div :class="[labelClass]">{{ label }}</div>
                <icon-chevron-down class="ml-1 h-4 w-4 transform transition duration-300"
                                   :class="show ? 'rotate-90' : ''"></icon-chevron-down>
            </template>

            <slot v-else name="labelHeader"></slot>
        </button>

        <!-- Dropdown Options -->
        <transition name="fade">
            <div v-show="show"
                 class="z-50 items-left bg-white mt-2 py-1 rounded-md shadow-xl ring-1 ring-black ring-opacity-5 overflow-y-auto overscroll-none scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-indigo-100"
                 ref="menuPopup"
                 style="border-top: 3px solid rgb(226, 27, 34); max-height: 60vh">

                <slot name="additionalInfo" class="border-b border-gray-200 px-4 py-2 w-full"></slot>

                <div @click.prevent="emitEvent">
                    <slot name="buttonOptions"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
    name: "SimpleDropdown",

    props: {
        label: {
            type: String,
            required: false,
            default: null
        },
        justifyText: {
            type: String,
            default: "justify-center",
            required: false
        },
        origin: {
            type: String,
            required: false,
            default: "bottom-end"
        },
        buttonClass: {
            required: false,
            type: String,
            default () {
                let buttonClasses =
                    "rounded-md justify-center items-center border border-gray-300 shadow-sm py-2 bg-white font-normal text-gray-700 hover:bg-indigo-50 hover:border-indigo-300 hover:text-indigo-600 focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-600";
                buttonClasses = this.label ? buttonClasses + " pl-3 pr-2" : "px-4";
                return buttonClasses;
            }
        },
        labelClass: {
            required: false,
            type: String,
            default () {
                return 'whitespace-nowrap truncate';
            }
        },
    },

    data () {
        return {
            popperInstance: null,
            show: false
        };
    },

    mounted () {
        const button = this.$refs.menuButtonContainer;
        const popup = this.$refs.menuPopup;
        if (!this.popperInstance) {
            this.popperInstance = createPopper(button, popup, {
                placement: this.origin,
                modifiers: [
                    {
                        name: "preventOverflow",
                        options: {
                            resize: true,
                            mainAxis: false, // true by default
                            strategy: "fixed",
                        },
                    }
                ]
            });

            this.popperInstance.update();
        }
    },

    methods: {
        emitEvent (event) {
            this.hidePopup();
            // I figured out by printing the event that this is the way to get the value of a selected Object.
            // If you only use event.target.value for Objects, you get a result of [Object object]
            if (event && event.target && event.target.__vue__._props && event.target.__vue__._props.value) {
                this.$emit("input", event.target.__vue__._props.value);
            } else {
                this.$emit("input", event.target.value);
            }
        },

        openPopup () {
            if (this.show) {
                this.hidePopup();
                return;
            }

            this.show = true;
            this.$nextTick(function () {
                this.popperInstance.update();
            });
        },

        hidePopup () {
            this.show = false;
        },
    },
};
</script>
